import { PREDICTION_STATE } from '@/types/taxonomyConst';

const predictionStateUtils = {
  getPredictionMessage: (payload: PredictionProgressPayload) => {
    const percentage = payload.progress_rate
      ? Number((payload.progress_rate * 100).toFixed(1))
      : 0;
    switch (payload.prediction_state) {
      case PREDICTION_STATE.IDLE:
        return null;
      case PREDICTION_STATE.WAITING:
        return 'Stand by… Creating your topic now.';
      case PREDICTION_STATE.TRAINING:
      case PREDICTION_STATE.SVM_CLASSIFICATION:
      case PREDICTION_STATE.LLM_CLASSIFICATION:
        if (percentage < 30) return `AI Training in progress... ${percentage}%`;
        if (percentage < 60)
          return `Classifying your feedback... ${percentage}%`;
        if (percentage < 100)
          return `Organizing you feedback now... ${percentage}%`;
        if (percentage === 100)
          return `Almost done! Just wrapping it up... ${percentage}%`;

        return `AI Training in progress... ${percentage}%`;
      case PREDICTION_STATE.RULE_CLASSIFICATION:
        return 'Organizing your feedback now...';
      default:
        throw new Error('Invalid prediction state');
    }
  },
  isPrediction: (state?: PREDICTION_STATE) => {
    if (typeof state === 'undefined') return false;
    if (state === PREDICTION_STATE.IDLE) return false;
    return true;
  },
};

export default predictionStateUtils;
